// Static exercise database categorized by muscle group and equipment requirements

export const exercises = {
  // Upper Body - Push
  push: [
    { name: 'Push-ups', equipment: ['bodyweight'], sets: 3, reps: '10-15' },
    { name: 'Diamond Push-ups', equipment: ['bodyweight'], sets: 3, reps: '8-12' },
    { name: 'Pike Push-ups', equipment: ['bodyweight'], sets: 3, reps: '8-12' },
    { name: 'Dumbbell Bench Press', equipment: ['dumbbells'], sets: 3, reps: '10-12' },
    { name: 'Dumbbell Shoulder Press', equipment: ['dumbbells'], sets: 3, reps: '10-12' },
    { name: 'Dumbbell Flyes', equipment: ['dumbbells'], sets: 3, reps: '12-15' },
    { name: 'Bench Press', equipment: ['gym'], sets: 4, reps: '8-10' },
    { name: 'Incline Bench Press', equipment: ['gym'], sets: 3, reps: '10-12' },
    { name: 'Cable Flyes', equipment: ['gym'], sets: 3, reps: '12-15' },
    { name: 'Military Press', equipment: ['gym'], sets: 4, reps: '8-10' },
  ],

  // Upper Body - Pull
  pull: [
    { name: 'Inverted Rows', equipment: ['bodyweight'], sets: 3, reps: '10-12' },
    { name: 'Pull-ups', equipment: ['bodyweight', 'gym'], sets: 3, reps: '6-10' },
    { name: 'Chin-ups', equipment: ['bodyweight', 'gym'], sets: 3, reps: '6-10' },
    { name: 'Dumbbell Rows', equipment: ['dumbbells'], sets: 3, reps: '10-12' },
    { name: 'Dumbbell Pullovers', equipment: ['dumbbells'], sets: 3, reps: '12-15' },
    { name: 'Bent Over Rows', equipment: ['gym'], sets: 4, reps: '8-10' },
    { name: 'Lat Pulldown', equipment: ['gym'], sets: 3, reps: '10-12' },
    { name: 'Seated Cable Row', equipment: ['gym'], sets: 3, reps: '10-12' },
    { name: 'Face Pulls', equipment: ['gym'], sets: 3, reps: '15-20' },
  ],

  // Lower Body
  legs: [
    { name: 'Bodyweight Squats', equipment: ['bodyweight'], sets: 3, reps: '15-20' },
    { name: 'Lunges', equipment: ['bodyweight'], sets: 3, reps: '12 each' },
    { name: 'Bulgarian Split Squats', equipment: ['bodyweight'], sets: 3, reps: '10 each' },
    { name: 'Glute Bridges', equipment: ['bodyweight'], sets: 3, reps: '15-20' },
    { name: 'Goblet Squats', equipment: ['dumbbells'], sets: 3, reps: '12-15' },
    { name: 'Dumbbell Lunges', equipment: ['dumbbells'], sets: 3, reps: '10 each' },
    { name: 'Dumbbell RDL', equipment: ['dumbbells'], sets: 3, reps: '10-12' },
    { name: 'Barbell Squats', equipment: ['gym'], sets: 4, reps: '8-10' },
    { name: 'Leg Press', equipment: ['gym'], sets: 3, reps: '10-12' },
    { name: 'Romanian Deadlifts', equipment: ['gym'], sets: 3, reps: '10-12' },
    { name: 'Leg Curls', equipment: ['gym'], sets: 3, reps: '12-15' },
    { name: 'Calf Raises', equipment: ['gym'], sets: 4, reps: '15-20' },
  ],

  // Core
  core: [
    { name: 'Plank', equipment: ['bodyweight'], sets: 3, reps: '30-60s' },
    { name: 'Dead Bug', equipment: ['bodyweight'], sets: 3, reps: '10 each' },
    { name: 'Mountain Climbers', equipment: ['bodyweight'], sets: 3, reps: '20 each' },
    { name: 'Bicycle Crunches', equipment: ['bodyweight'], sets: 3, reps: '15 each' },
    { name: 'Russian Twists', equipment: ['dumbbells'], sets: 3, reps: '15 each' },
    { name: 'Weighted Crunches', equipment: ['dumbbells'], sets: 3, reps: '15-20' },
    { name: 'Cable Woodchops', equipment: ['gym'], sets: 3, reps: '12 each' },
    { name: 'Hanging Leg Raises', equipment: ['gym'], sets: 3, reps: '10-15' },
  ],

  // Cardio/Endurance
  cardio: [
    { name: 'Running', equipment: ['cardio'], sets: 1, reps: '20-40 min' },
    { name: 'Cycling', equipment: ['cardio'], sets: 1, reps: '30-45 min' },
    { name: 'Jump Rope', equipment: ['bodyweight'], sets: 3, reps: '3 min' },
    { name: 'Burpees', equipment: ['bodyweight'], sets: 3, reps: '10-15' },
    { name: 'High Knees', equipment: ['bodyweight'], sets: 3, reps: '30s' },
    { name: 'Jumping Jacks', equipment: ['bodyweight'], sets: 3, reps: '30s' },
    { name: 'Rowing Machine', equipment: ['gym'], sets: 1, reps: '15-20 min' },
    { name: 'Stair Climber', equipment: ['gym'], sets: 1, reps: '15-20 min' },
  ],

  // Sport-Specific Drills
  sportDrills: {
    running: [
      { name: 'Tempo Run', equipment: ['cardio'], sets: 1, reps: '20-30 min' },
      { name: 'Interval Sprints', equipment: ['cardio'], sets: 6, reps: '400m' },
      { name: 'Hill Repeats', equipment: ['cardio'], sets: 5, reps: '200m' },
      { name: 'Easy Recovery Run', equipment: ['cardio'], sets: 1, reps: '25-35 min' },
    ],
    cycling: [
      { name: 'Endurance Ride', equipment: ['cardio'], sets: 1, reps: '45-60 min' },
      { name: 'Hill Intervals', equipment: ['cardio'], sets: 6, reps: '3 min' },
      { name: 'Tempo Ride', equipment: ['cardio'], sets: 1, reps: '30-40 min' },
      { name: 'Recovery Spin', equipment: ['cardio'], sets: 1, reps: '30 min' },
    ],
    swimming: [
      { name: 'Technique Drills', equipment: ['bodyweight'], sets: 4, reps: '50m' },
      { name: 'Endurance Swim', equipment: ['bodyweight'], sets: 1, reps: '800-1500m' },
      { name: 'Sprint Intervals', equipment: ['bodyweight'], sets: 8, reps: '25m' },
      { name: 'Mixed Stroke Practice', equipment: ['bodyweight'], sets: 4, reps: '100m' },
    ],
    soccer: [
      { name: 'Agility Ladder Drills', equipment: ['bodyweight'], sets: 4, reps: '30s' },
      { name: 'Shuttle Runs', equipment: ['bodyweight'], sets: 6, reps: '20m' },
      { name: 'Ball Control Drills', equipment: ['bodyweight'], sets: 3, reps: '5 min' },
      { name: 'Sprint Recovery Intervals', equipment: ['cardio'], sets: 8, reps: '30s on/30s off' },
    ],
    basketball: [
      { name: 'Court Sprints', equipment: ['bodyweight'], sets: 8, reps: 'full court' },
      { name: 'Defensive Slides', equipment: ['bodyweight'], sets: 4, reps: '30s' },
      { name: 'Box Jumps', equipment: ['bodyweight'], sets: 4, reps: '10' },
      { name: 'Lateral Agility', equipment: ['bodyweight'], sets: 4, reps: '20s' },
    ],
    tennis: [
      { name: 'Lateral Shuffles', equipment: ['bodyweight'], sets: 4, reps: '30s' },
      { name: 'Split Step Drills', equipment: ['bodyweight'], sets: 3, reps: '1 min' },
      { name: 'Forehand/Backhand Shadow', equipment: ['bodyweight'], sets: 3, reps: '20 each' },
      { name: 'Court Coverage Sprints', equipment: ['bodyweight'], sets: 6, reps: '15s' },
    ],
    crossfit: [
      { name: 'AMRAP Circuit', equipment: ['bodyweight'], sets: 1, reps: '15 min' },
      { name: 'EMOM Training', equipment: ['bodyweight', 'dumbbells'], sets: 10, reps: '10 reps' },
      { name: 'Kettlebell Swings', equipment: ['dumbbells'], sets: 4, reps: '15-20' },
      { name: 'Box Jumps', equipment: ['gym'], sets: 4, reps: '10-12' },
    ],
    weightlifting: [
      { name: 'Clean & Jerk Practice', equipment: ['gym'], sets: 5, reps: '3' },
      { name: 'Snatch Technique', equipment: ['gym'], sets: 5, reps: '3' },
      { name: 'Front Squats', equipment: ['gym'], sets: 4, reps: '5' },
      { name: 'Overhead Squats', equipment: ['gym'], sets: 3, reps: '5' },
    ],
    powerlifting: [
      { name: 'Competition Squat', equipment: ['gym'], sets: 5, reps: '5' },
      { name: 'Competition Bench', equipment: ['gym'], sets: 5, reps: '5' },
      { name: 'Competition Deadlift', equipment: ['gym'], sets: 5, reps: '3' },
      { name: 'Pause Squats', equipment: ['gym'], sets: 3, reps: '5' },
    ],
    bodybuilding: [
      { name: 'Isolation Curls', equipment: ['dumbbells', 'gym'], sets: 4, reps: '12-15' },
      { name: 'Tricep Extensions', equipment: ['dumbbells', 'gym'], sets: 4, reps: '12-15' },
      { name: 'Lateral Raises', equipment: ['dumbbells'], sets: 4, reps: '15-20' },
      { name: 'Leg Extensions', equipment: ['gym'], sets: 4, reps: '12-15' },
    ],
    martialArts: [
      { name: 'Shadow Boxing', equipment: ['bodyweight'], sets: 5, reps: '3 min' },
      { name: 'Kick Drills', equipment: ['bodyweight'], sets: 4, reps: '20 each' },
      { name: 'Sprawl Practice', equipment: ['bodyweight'], sets: 4, reps: '10' },
      { name: 'Conditioning Circuit', equipment: ['bodyweight'], sets: 3, reps: '5 min' },
    ],
    yoga: [
      { name: 'Sun Salutations', equipment: ['bodyweight'], sets: 5, reps: 'flow' },
      { name: 'Balance Sequence', equipment: ['bodyweight'], sets: 1, reps: '10 min' },
      { name: 'Hip Opening Flow', equipment: ['bodyweight'], sets: 1, reps: '15 min' },
      { name: 'Strength Flow', equipment: ['bodyweight'], sets: 1, reps: '20 min' },
    ],
    general: [
      { name: 'Dynamic Warm-up', equipment: ['bodyweight'], sets: 1, reps: '5 min' },
      { name: 'Mobility Work', equipment: ['bodyweight'], sets: 1, reps: '10 min' },
      { name: 'Active Recovery', equipment: ['bodyweight'], sets: 1, reps: '20 min' },
      { name: 'Flexibility Routine', equipment: ['bodyweight'], sets: 1, reps: '15 min' },
    ],
  },
};

// Sport categorization
export const sportCategories = {
  endurance: ['running', 'cycling', 'swimming', 'triathlon'],
  equipment: ['soccer', 'basketball', 'tennis', 'volleyball', 'baseball', 'golf'],
  strength: [
    'crossfit',
    'weightlifting',
    'powerlifting',
    'bodybuilding',
    'martialArts',
    'calisthenics',
  ],
  flexibility: ['yoga', 'pilates'],
  general: ['general'],
};

export const sports = [
  { value: 'running', label: 'Running', icon: '🏃' },
  { value: 'cycling', label: 'Cycling', icon: '🚴' },
  { value: 'swimming', label: 'Swimming', icon: '🏊' },
  { value: 'soccer', label: 'Soccer/Football', icon: '⚽' },
  { value: 'basketball', label: 'Basketball', icon: '🏀' },
  { value: 'tennis', label: 'Tennis', icon: '🎾' },
  { value: 'crossfit', label: 'CrossFit', icon: '🏋️' },
  { value: 'weightlifting', label: 'Weightlifting', icon: '🏋️‍♂️' },
  { value: 'powerlifting', label: 'Powerlifting', icon: '💪' },
  { value: 'bodybuilding', label: 'Bodybuilding', icon: '💪' },
  { value: 'martialArts', label: 'Martial Arts', icon: '🥋' },
  { value: 'yoga', label: 'Yoga', icon: '🧘' },
  { value: 'general', label: 'General Fitness', icon: '🎯' },
];

export const equipmentOptions = [
  { value: 'bodyweight', label: 'Bodyweight Only', icon: '🤸' },
  { value: 'cardio', label: 'Running/Cycling', icon: '🏃' },
  { value: 'dumbbells', label: 'Dumbbells', icon: '🏋️' },
  { value: 'gym', label: 'Full Gym', icon: '🏢' },
];

export const levels = [
  { value: 'beginner', label: 'Beginner', description: 'New to training' },
  { value: 'intermediate', label: 'Intermediate', description: '1-3 years experience' },
  { value: 'advanced', label: 'Advanced', description: '3+ years experience' },
];
